export enum RiskIndicatorEnum {
  model = 'model',
}

export interface RiskIndicatorType {
  href: string;
  color: string;
  hoverColor?: string;
  icon: React.ReactNode;
  info: string;
  title: string;
  name: string;
  type?: RiskIndicatorEnum;
}
